export default "__VITE_ASSET__e1dfc978__"